import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Api_Url } from "../../config/config";
import axios from "axios";
import { Button, Divider, Modal, Table } from "antd";
import {
  ErrorToast,
  SuccessToast,
  UpdatedToast,
} from "../../views/ToastComponent";

function TentHouseDetails() {
  const { id } = useParams();

  const [singleData, setSingleData] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isDepriciationModalOpen, setIsDepriciationModalOpen] = useState(false);
  const [isDepriciationEditModalOpen, setIsDepriciationEditModalOpen] =
    useState(false);
  const [activeTab, setActiveTab] = useState("home");

  const getSingleUser = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/TentHouse/labour/getalltenthouselabourbytenthouseid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setSingleData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    getSingleUser();
  }, []);

  const [tentHouseData, setTentHouseData] = useState({
    tentHouseId: id,
    name: "",
    count: 0,
    total: 0,
    payout: 0,
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setTentHouseData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/TentHouse/labour`,
        tentHouseData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        SuccessToast("Added Successfully");
        handleCancel();
        getSingleUser();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error.message;
    }
  };

  const handleClick = async (id) => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/TentHouse/labour/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setTentHouseData(response.data.data);
      setIsEditModalOpen(true);
    } catch (error) {
      return error.message;
    }
  };

  const handleUpdate = async (id) => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/TentHouse/labour/${id}`,
        tentHouseData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        UpdatedToast("Successfully updated");
        handleCancel();
        getSingleUser();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error;
    }
  };

  const calculateMonthlyRevenue = () => {
    const result = tentHouseData.count * tentHouseData.payout;
    setTentHouseData((prev) => ({
      ...prev,
      total: result,
    }));
  };

  useEffect(() => {
    calculateMonthlyRevenue();
  }, [tentHouseData.count, tentHouseData.payout]);

  const columns = [
    {
      title: "Labour",
      dataIndex: "name",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "labour charge",
      dataIndex: "payout",
      // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
    },
    {
      title: "Number Of Labour",
      dataIndex: "count",
      // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
    },
    {
      title: "Created At",
      dataIndex: "created",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Edit",
      dataIndex: "edit",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            className="btn btn-danger"
            type="primary"
            // onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  async function handleCancel() {
    setTentHouseData({
      ...tentHouseData,
      tentHouseId: id,
      name: "",
      count: 0,
      total: 0,
      payout: 0,
    });
    setIsEditModalOpen(false);
    setIsModalOpen(false);
  }

  // Depriciation Method

  const [getDeptSingleData, setGetDeptSingleData] = useState([]);

  const getDeptSingleUser = async () => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/TentHouse/item/getalltenthouseitembytenthouseid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setGetDeptSingleData(response.data.data);
    } catch (error) {
      return error.message;
    }
  };

  useEffect(() => {
    getDeptSingleUser();
  }, []);

  const handleDeptClick = async (id) => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/TentHouse/item/${id}`,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      setTentDeptHouseData(response.data.data);
      setIsDepriciationEditModalOpen(true);
    } catch (error) {
      return error.message;
    }
  };

  const [tentDeptHouseData, setTentDeptHouseData] = useState({
    tentHouseId: id,
    name: "",
    purchase: 0,
    quantity: 0,
    durability: 0,
    depression: 0,
    latitude: "",
    longitude: "",
  });

  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(function (position) {
        const { latitude, longitude } = position.coords;
        setTentDeptHouseData((prev) => ({
          ...prev,
          latitude: latitude.toString(),
          longitude: longitude.toString(),
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleDeptSubmit = async () => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/TentHouse/item`,
        tentDeptHouseData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        SuccessToast("Added successfully");
        handleAllCancel();
        getDeptSingleUser();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error.message;
    }
  };

  const handleDeptUpdate = async (id) => {
    try {
      const response = await axios.post(
        `${Api_Url}api/v1/TentHouse/item/${id}`,
        tentDeptHouseData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
          },
        }
      );
      if (response.data.succeeded) {
        UpdatedToast("Successfully updated");
        handleAllCancel();
        getDeptSingleUser();
      }
    } catch (error) {
      ErrorToast("Something went wrong");
      return error;
    }
  };

  const col = [
    {
      title: "Item",
      dataIndex: "name",
      // sorter: (a, b) => a.profitMarginName.length - b.profitMarginName.length,
    },
    {
      title: "Cost",
      dataIndex: "purchase",
      // sorter: (a, b) => a.registrationNumber.length - b.registrationNumber.length,
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      // sorter: (a, b) => a.purchaseCost.length - b.purchaseCost.length,
    },
    {
      title: "Depreciation/Month",
      dataIndex: "depression",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Durability",
      dataIndex: "durability",
      // sorter: (a, b) => a.lifeOfAuto.length - b.lifeOfAuto.length,
    },
    {
      title: "Edit",
      dataIndex: "edit",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            type="primary"
            onClick={() => handleDeptClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-pen-to-square"></i>
          </Button>
        </div>
      ),
    },
    {
      title: "Delete",
      dataIndex: "delete",
      // sorter: (a, b) => a.monthlyIncome.length - b.monthlyIncome.length,
      render: (text, record) => (
        <div>
          {text}
          <Button
            className="btn btn-danger"
            type="primary"
            // onClick={() => handleClick(record.id)}
            style={{ marginLeft: "10px" }}
          >
            <i class="fa-solid fa-trash"></i>
          </Button>
        </div>
      ),
    },
  ];

  const calculateDeptPerMOnth = () => {
    const result = tentDeptHouseData.purchase * tentDeptHouseData.quantity || 0;
    setTentDeptHouseData((prev) => ({
      ...prev,
      depression: result / tentDeptHouseData.durability,
    }));
  };

  useEffect(() => {
    calculateDeptPerMOnth();
  }, [
    tentDeptHouseData.purchase,
    tentDeptHouseData.durability,
    tentDeptHouseData.quantity,
  ]);

  async function handleAllCancel() {
    setTentDeptHouseData({
      ...tentDeptHouseData,
      tentHouseId: id,
      name: "",
      purchase: 0,
      quantity: 0,
      durability: 0,
      depression: 0,
    });
    setIsDepriciationModalOpen(false);
    setIsDepriciationEditModalOpen(false);
  }

  useEffect(() => {
    const saveTab = localStorage.getItem("activateTab");
    if (saveTab) {
      setActiveTab(saveTab);
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("activateTab", activeTab);
  }, [activeTab]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">
          {/* Tabs */}

          <nav>
            <div class="nav nav-tabs" id="nav-tab" role="tablist">
              <button
                class={`nav-link ${activeTab === "home" ? "active" : ""}`}
                id="nav-home-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-home"
                type="button"
                role="tab"
                aria-controls="nav-home"
                aria-selected={activeTab === "home"}
                onClick={() => setActiveTab("home")}
              >
                Labour
              </button>
              <button
                class={`nav-link ${activeTab === "profile" ? "active" : ""}`}
                id="nav-profile-tab"
                data-bs-toggle="tab"
                data-bs-target="#nav-profile"
                type="button"
                role="tab"
                aria-controls="nav-profile"
                aria-selected={activeTab === "profile"}
                onClick={() => setActiveTab("profile")}
              >
                Depreciation
              </button>
            </div>
          </nav>
          <div class="tab-content" id="nav-tabContent">
            {/* Starting Labour Tab */}

            <div
              class="tab-pane fade show active"
              id="nav-home"
              role="tabpanel"
              aria-labelledby="nav-home-tab"
            >
              <div className="row">
                <div className="col-12 d-flex align-items-center justify-content-between">
                  <h3 className="mb-0">Tent House Assesment</h3>
                  <button
                    className="btn btn-primary submit-btn mb-2"
                    onClick={() => setIsModalOpen(true)}
                  >
                    Labour cost
                  </button>
                </div>
              </div>

              <div className="row mt-4">
                <div className="col-12 mx-auto">
                  <Table
                    className="table-striped"
                    style={{ overflowX: "auto" }}
                    columns={columns}
                    dataSource={singleData}
                    rowKey={(record) => record.id}
                  />
                </div>
              </div>
            </div>
          </div>
          <Modal
            title={<h4>Add Tent House</h4>}
            open={isModalOpen}
            onOk={() => setIsModalOpen(false)}
            onCancel={() => handleCancel()}
            footer={[
              <div className="d-flex justify-content-between align-items-center">
                <button
                  key="Cancel"
                  className="btn btn-danger submit-btn"
                  type="button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                ,
                <button
                  key="submit"
                  className="btn btn-primary submit-btn"
                  type="submit"
                  onClick={handleSubmit}
                >
                  Submit
                </button>
              </div>,
            ]}
            width={600}
            masked={false}
            maskClosable={false}
            closeIcon={<span style={{ color: 'red' }}>X</span>}
          >
            <div className="modal-body mt-5">
              <form>
                <Divider>Tent House</Divider>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Worker Type Name:
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Worker Type Name"
                        value={tentHouseData.name}
                        onChange={(e) =>
                          setTentHouseData({
                            ...tentHouseData,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">No. of Labour:</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="No. of Labour"
                        value={tentHouseData.count}
                        onChange={(e) =>
                          setTentHouseData({
                            ...tentHouseData,
                            count: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Labour Charge:</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Labour Charge"
                        value={tentHouseData.payout}
                        onChange={(e) =>
                          setTentHouseData({
                            ...tentHouseData,
                            payout: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between">
                    <p className="mb-0">Total: </p>
                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                      &#8377; {Number(tentHouseData.total).toFixed(2)}
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </Modal>

          {/* Edit Modal */}
          <Modal
            title={<h4>Edit Tent House</h4>}
            open={isEditModalOpen}
            onOk={() => setIsEditModalOpen(false)}
            onCancel={() => handleCancel()}
            footer={[
              <div className="d-flex justify-content-between align-items-center">
                <button
                  key="Cancel"
                  className="btn btn-danger submit-btn"
                  type="button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
                ,
                <button
                  key="submit"
                  className="btn btn-primary submit-btn"
                  type="submit"
                  onClick={() => handleUpdate(tentHouseData.id)}
                >
                  Update
                </button>
              </div>,
            ]}
            width={600}
            masked={false}
            maskClosable={false}
            closeIcon={<span style={{ color: 'red' }}>X</span>}
          >
            <div className="modal-body mt-5">
              <form>
                <Divider>Tent House</Divider>
                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">
                        Worker Type Name:
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Worker Type Name"
                        value={tentHouseData.name}
                        onChange={(e) =>
                          setTentHouseData({
                            ...tentHouseData,
                            name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">No. of Labour:</label>
                      <input
                        className="form-control"
                        type="number"
                        placeholder="No. of Labour"
                        value={tentHouseData.count}
                        onChange={(e) =>
                          setTentHouseData({
                            ...tentHouseData,
                            count: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-6">
                    <div className="input-block mb-3">
                      <label className="col-form-label">Labour Charge:</label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter Daily Grind In kg"
                        value={tentHouseData.payout}
                        onChange={(e) =>
                          setTentHouseData({
                            ...tentHouseData,
                            payout: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="row my-3">
                  <div className="col-sm-12 d-flex align-items-center justify-content-between">
                    <p className="mb-0">Total: </p>
                    <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                      &#8377; {Number(tentHouseData.total).toFixed(2)}
                    </span>
                  </div>
                </div>
              </form>
            </div>
          </Modal>
        </div>

        {/* Starting Depreciation Tabs */}

        <div
          class="tab-pane fade"
          id="nav-profile"
          role="tabpanel"
          aria-labelledby="nav-profile-tab"
        >
          {/* <div className="page-wrapper"> */}
          <div className="content container-fluid">
            <div className="row">
              <div className="col-12 d-flex align-items-center justify-content-between">
                <h3 className="mb-0">Tent House </h3>
                <button
                  className="btn btn-primary submit-btn mb-2"
                  onClick={() => setIsDepriciationModalOpen(true)}
                >
                  Depreciation Cost
                </button>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-12 mx-auto">
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto" }}
                  columns={col}
                  dataSource={getDeptSingleData}
                  rowKey={(record) => record.id}
                />
              </div>
            </div>

            <Modal
              title={<h4>Tent House</h4>}
              open={isDepriciationModalOpen}
              onOk={() => setIsDepriciationModalOpen(false)}
              onCancel={() => handleAllCancel()}
              footer={[
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    key="Cancel"
                    className="btn btn-danger submit-btn"
                    type="button"
                    onClick={handleAllCancel}
                  >
                    Cancel
                  </button>
                  ,
                  <button
                    key="submit"
                    className="btn btn-primary submit-btn"
                    type="submit"
                    onClick={handleDeptSubmit}
                  >
                    Submit
                  </button>
                </div>,
              ]}
              width={600}
              masked={false}
              maskClosable={false}
              closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
              <div className="modal-body mt-5">
                <form>
                  <Divider>Tent House</Divider>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Item Name:</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="item name"
                          value={tentDeptHouseData.name}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              name: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Purchase Cost:</label>
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Enter Purchase Cost"
                          value={tentDeptHouseData.purchase}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              purchase: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Quantity:</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Quantity"
                          value={tentDeptHouseData.quantity}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              quantity: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">
                          Durability In Month:
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Durability In Month"
                          value={tentDeptHouseData.durability}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              durability: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                      <p className="mb-0">Dept Per Month: </p>
                      <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                        &#8377;{" "}
                        {Number(tentDeptHouseData.depression).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </Modal>

            {/* Edit Depreciation Model */}

            <Modal
              title={<h4>Edit Tent House</h4>}
              open={isDepriciationEditModalOpen}
              onOk={() => setIsDepriciationEditModalOpen(false)}
              onCancel={() => handleAllCancel()}
              footer={[
                <div className="d-flex justify-content-between align-items-center">
                  <button
                    key="Cancel"
                    className="btn btn-danger submit-btn"
                    type="button"
                    onClick={handleAllCancel}
                  >
                    Cancel
                  </button>
                  ,
                  <button
                    key="submit"
                    className="btn btn-primary submit-btn"
                    type="submit"
                    onClick={() => handleDeptUpdate(tentDeptHouseData.id)}
                  >
                    Submit
                  </button>
                </div>,
              ]}
              width={600}
              masked={false}
              maskClosable={false}
              closeIcon={<span style={{ color: 'red' }}>X</span>}
            >
              <div className="modal-body mt-5">
                <form>
                  <Divider>Tent House</Divider>
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Item Name:</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="item name"
                          value={tentDeptHouseData.name}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              name: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Purchase Cost:</label>
                        <input
                          className="form-control"
                          type="number"
                          placeholder="Enter Purchase Cost"
                          value={tentDeptHouseData.purchase}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              purchase: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">Quantity:</label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Quantity"
                          value={tentDeptHouseData.quantity}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              quantity: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="input-block mb-3">
                        <label className="col-form-label">
                          Durability In Month:
                        </label>
                        <input
                          className="form-control"
                          type="text"
                          placeholder="Durability In Month"
                          value={tentDeptHouseData.durability}
                          onChange={(e) =>
                            setTentDeptHouseData({
                              ...tentDeptHouseData,
                              durability: e.target.value,
                            })
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row my-3">
                    <div className="col-sm-12 d-flex align-items-center justify-content-between">
                      <p className="mb-0">Dept Per Month: </p>
                      <span className="mb-0 bg-dark py-1 px-2 text-light fw-bold rounded">
                        &#8377;{" "}
                        {Number(tentDeptHouseData.depression).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </form>
              </div>
            </Modal>
            {/* </div> */}
          </div>
        </div>
      </div>
    </>
  );
}

export default TentHouseDetails;
